const buildDefaultApiScope = () => {
  const apiClientId = process.env.REACT_APP_AAD_CLIENT_ID;

  if (!apiClientId) {
    return "User.Read";
  }

  return `api://${apiClientId}/access_as_user`;
};

const DEFAULT_SCOPE = buildDefaultApiScope();

const parseScopes = (rawScopes) => {
  if (!rawScopes || typeof rawScopes !== "string") return [];

  return rawScopes
    .split(/[,\s]+/)
    .map((scope) => scope.trim())
    .filter(Boolean);
};

export const AUTH_SCOPES = parseScopes(process.env.REACT_APP_AAD_SCOPE);
export const AUTH_SCOPE = AUTH_SCOPES[0] || DEFAULT_SCOPE;
export const LOGIN_SCOPES = ["openid", "profile", "offline_access"];

const getDefaultRedirectUri = () => {
  if (typeof window === "undefined") return "/";

  return `${window.location.origin}/Reports/auth/callback`;
};

const getDefaultPostLogoutRedirectUri = () => {
  if (typeof window === "undefined") return "/";

  return `${window.location.origin}/Reports/`;
};

const normalizeConfiguredUri = (value) => {
  if (!value || typeof value !== "string") return value;

  const trimmedValue = value.trim();

  // Recover from values like "myapp.azurewebsites.net/Reports/auth/callback".
  if (/^[^/]+\.[^/]+\//.test(trimmedValue) && !/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmedValue)) {
    const protocol = typeof window !== "undefined" ? window.location.protocol || "https:" : "https:";

    return `${protocol}//${trimmedValue}`;
  }

  return trimmedValue;
};

const parseAbsoluteHttpUrl = (value) => {
  if (!value || typeof value !== "string") return null;

  try {
    const parsedUrl = new URL(normalizeConfiguredUri(value));

    if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
      return null;
    }

    return parsedUrl;
  } catch {
    return null;
  }
};

const shouldIgnoreConfiguredUri = (configuredUri) => {
  if (typeof window === "undefined") return false;

  const parsedConfiguredUri = parseAbsoluteHttpUrl(configuredUri);

  if (!parsedConfiguredUri) {
    return Boolean(configuredUri);
  }

  const runningOnLocalhost =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const configuredPointsToLocalhost =
    parsedConfiguredUri.hostname === "localhost" || parsedConfiguredUri.hostname === "127.0.0.1";

  if (!runningOnLocalhost && parsedConfiguredUri.origin !== window.location.origin) {
    return true;
  }

  return configuredPointsToLocalhost && !runningOnLocalhost;
};

const resolveRedirectUri = (configuredUri, fallbackUri) =>
  shouldIgnoreConfiguredUri(configuredUri)
    ? fallbackUri
    : normalizeConfiguredUri(configuredUri) || fallbackUri;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID,
    authority: process.env.REACT_APP_AAD_AUTHORITY,
    redirectUri: resolveRedirectUri(
      process.env.REACT_APP_AAD_REDIRECT_URI,
      getDefaultRedirectUri(),
    ),
    postLogoutRedirectUri: resolveRedirectUri(
      process.env.REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI,
      getDefaultPostLogoutRedirectUri(),
    ),
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: Array.from(
    new Set([...LOGIN_SCOPES, ...(AUTH_SCOPES.length ? AUTH_SCOPES : [DEFAULT_SCOPE])]),
  ),
};

export const tokenRequest = {
  scopes: AUTH_SCOPES.length ? AUTH_SCOPES : [DEFAULT_SCOPE],
};
